import type { Country } from "@core/schema/Country.js";

export const selectedDestinationCountry = $state<{ current: Country | "outsideEu" | null }>({ current: null });
